var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutDots = function SvgAboutDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#204969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AboutDots_svg__a)",
    d: "M61.714 27.914a.89.89 0 0 0-.784.464l-5.082 9.307-5.87 10.746a.892.892 0 0 1-1.566 0l-5.868-10.746-5.083-9.307a.89.89 0 0 0-.783-.464H21.415a.892.892 0 0 0-.773 1.338l13.987 24.226 13.986 24.225a.892.892 0 0 0 1.546 0l13.986-24.226 13.987-24.225a.892.892 0 0 0-.773-1.338z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AboutDots_svg__b)",
    d: "M61.714 27.914a.89.89 0 0 0-.784.464l-5.082 9.307-5.87 10.746a.892.892 0 0 1-1.566 0l-5.868-10.745-5.083-9.308a.89.89 0 0 0-.783-.464H21.415a.892.892 0 0 0-.773 1.338l.441.764c2.847 3.73 7.07 9.463 11.406 15.519l4.28 5.975c6.94 9.692 18.299 9.692 25.24 0l4.279-5.975c3.784-5.285 7.62-10.386 10.613-14.165a1 1 0 0 0 .073-.108l1.16-2.01a.892.892 0 0 0-.772-1.338z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AboutDots_svg__c)",
    d: "M50.012 45.366a.892.892 0 0 1-1.567 0l-5.211-9.542-5.274-9.656a.892.892 0 0 1 .783-1.32h20.97a.892.892 0 0 1 .783 1.32l-5.274 9.656z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AboutDots_svg__d)",
    d: "M38.625 25.233a.446.446 0 0 0-.26.808l4.068 2.923a11.645 11.645 0 0 0 13.59 0l4.069-2.922a.446.446 0 0 0-.26-.81H38.624"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AboutDots_svg__a",
    x1: 49.388,
    x2: 49.388,
    y1: 27.914,
    y2: 79.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AboutDots_svg__b",
    x1: 49.41,
    x2: 49.41,
    y1: 15.604,
    y2: 54.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AboutDots_svg__c",
    x1: 49.245,
    x2: 49.228,
    y1: 8.882,
    y2: 46.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AboutDots_svg__d",
    x1: 49.245,
    x2: 49.228,
    y1: 18.892,
    y2: 31.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCF7"
  })))));
};
export default SvgAboutDots;